module.exports = __webpack_public_path__ + "img/xcx_ma.6a9b2ed4.png";